var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 12,
    fill: "url(#paint0_linear_6_5949)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7329 30.5588L15.1563 30.8086C16.935 31.8594 18.9744 32.4153 21.0541 32.4163H21.0585C27.4452 32.4163 32.6431 27.2428 32.6457 20.8842C32.6469 17.8029 31.4427 14.9053 29.255 12.7256C28.1819 11.6506 26.9054 10.7983 25.4993 10.2178C24.0931 9.63727 22.5853 9.34021 21.063 9.34377C14.6713 9.34377 9.47328 14.5167 9.47101 20.8749C9.46786 23.0461 10.082 25.1738 11.2425 27.0121L11.5181 27.4482L10.3474 31.7034L14.7329 30.5588ZM7 35L8.97798 27.8104C7.75811 25.7064 7.11634 23.3194 7.1171 20.874C7.12032 13.2238 13.3739 7 21.0586 7C24.7878 7.00189 28.2881 8.44663 30.9205 11.0692C33.5529 13.6918 35.0013 17.1777 35 20.8851C34.9966 28.5348 28.742 34.7597 21.0585 34.7597H21.0524C18.7193 34.7587 16.4268 34.1761 14.3905 33.0707L7 35Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 35L8.97798 27.8104C7.75601 25.7013 7.11415 23.3088 7.1171 20.874C7.12032 13.2238 13.3739 7 21.0586 7C24.7878 7.00189 28.2881 8.44663 30.9205 11.0692C33.5529 13.6918 35.0013 17.1777 35 20.8851C34.9966 28.5348 28.7421 34.7597 21.0585 34.7597H21.0524C18.7193 34.7587 16.4268 34.176 14.3905 33.0707L7 35Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0043 9.00003C14.9366 9.00003 10.0022 14.1567 10 20.4949C9.99702 22.6593 10.58 24.7803 11.6816 26.6128L11.9434 27.0478L10.8319 31.2896L14.9953 30.1484L15.3973 30.3973C17.0858 31.4449 19.0217 31.9989 20.996 32H21.0002C27.0631 32 31.9976 26.8428 31.9999 20.5042C32.0045 18.9934 31.7224 17.4966 31.1699 16.1006C30.6174 14.7046 29.8054 13.437 28.7811 12.3712C27.7625 11.2996 26.5506 10.4499 25.2157 9.87124C23.8808 9.29257 22.4494 8.99646 21.0043 9.00003Z",
    fill: "url(#paint1_linear_6_5949)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5596 14.6503C17.3014 14.0319 17.0297 14.0194 16.7844 14.0087L16.1242 14C15.8945 14 15.5212 14.0929 15.2057 14.4647C14.8902 14.8364 14 15.7348 14 17.5621C14 19.3893 15.2344 21.155 15.4064 21.4031C15.5784 21.6512 17.7893 25.5205 21.2906 27.0092C24.2002 28.2464 24.7923 28.0003 25.4241 27.9385C26.0559 27.8767 27.4621 27.0401 27.7489 26.1729C28.0358 25.3056 28.036 24.5625 27.95 24.4072C27.864 24.2518 27.6343 24.1595 27.2895 23.9736C26.9447 23.7878 25.2515 22.8894 24.9358 22.7653C24.6201 22.6413 24.3906 22.5797 24.1607 22.9514C23.9308 23.3231 23.2714 24.1593 23.0704 24.4072C22.8693 24.6551 22.6687 24.6862 22.3239 24.5005C21.9792 24.3149 20.87 23.9225 19.5539 22.6573C18.5299 21.6728 17.8388 20.457 17.6375 20.0855C17.4363 19.714 17.6162 19.5128 17.7889 19.3277C17.9435 19.1613 18.1333 18.894 18.3059 18.6772C18.4784 18.4604 18.5352 18.3055 18.6499 18.058C18.7645 17.8105 18.7074 17.5932 18.6212 17.4075C18.535 17.2219 17.8657 15.3849 17.5596 14.6503Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_5949",
    x1: 20.5724,
    y1: 2.52045,
    x2: 20.7853,
    y2: 38.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_5949",
    x1: 20.776,
    y1: 10.3802,
    x2: 20.8979,
    y2: 30.0351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })))));
};
export default SvgWhatsapp;